export const POST_SHIFT_REQUEST = 'POST_SHIFT_REQUEST';
export const POST_SHIFT_SUCCESS = 'POST_SHIFT_SUCCESS';
export const POST_SHIFT_ERROR = 'POST_SHIFT_ERROR';

export const GET_SHIFT_INDICATORS_REQUEST = 'GET_SHIFT_INDICATORS_REQUEST';
export const GET_SHIFT_INDICATORS_SUCCESS = 'GET_SHIFT_INDICATORS_SUCCESS';
export const GET_SHIFT_INDICATORS_ERROR = 'GET_SHIFT_INDICATORS_ERROR';

export const POST_SHIFT_IS_CONSIDERED_REQUEST =
  'POST_SHIFT_IS_CONSIDERED_REQUEST';
export const POST_SHIFT_IS_CONSIDERED_SUCCESS =
  'POST_SHIFT_IS_CONSIDERED_SUCCESS';
export const POST_SHIFT_IS_CONSIDERED_ERROR = 'POST_SHIFT_IS_CONSIDERED_ERROR';

export const GET_IDLE_SHIFTS_FLAG_REQUEST = 'GET_IDLE_SHIFTS_REQUEST';
export const GET_IDLE_SHIFTS_FLAG_SUCCESS = 'GET_IDLE_SHIFTS_SUCCESS';
export const GET_IDLE_SHIFTS_FLAG_ERROR = 'GET_IDLE_SHIFTS_ERROR';

export const PUT_IDLE_SHIFTS_FLAG_REQUEST = 'PUT_IDLE_SHIFTS_REQUEST';
export const PUT_IDLE_SHIFTS_FLAG_SUCCESS = 'PUT_IDLE_SHIFTS_SUCCESS';
export const PUT_IDLE_SHIFTS_FLAG_ERROR = 'PUT_IDLE_SHIFTS_ERROR';
